export default __webpack_public_path__ + "static/media/wave2.da95914f.png";